<template>
    <vue-hcaptcha
        ref="hcaptcha"
        class="d-inline-block captcha-component captcha-hcaptcha"
        @verify="onVerify"
        @expired="onExpired"
        @rendered="onRender"
        :sitekey="sitekey"
        :size="size"
        :loadRecaptchaScript="true"
        :reCaptchaCompat="false"
        :language="language"
        :rqdata="rqdata"
        >
    </vue-hcaptcha>
</template>

<script>

export default {
    props: {
        sitekey: {
            type: String,
            required: true,
        },
        language: {
            type: String,
            required: true,
        },
        captchaId: {
            type: String,
            required: false,
            default: null,
        },
        size: {
          required: false,
          type: String,
          default: 'normal'
        },
        rqdata: {
            required: false,
            type: String,
            default: ""
        }
    },

    components: {
        VueHcaptcha: () => import(/* webpackChunkName: "chunk-vue-hcaptcha" */ "@hcaptcha/vue-hcaptcha"),
    },

    data: function(){
        return  {
            validResponse: null,
            isRendered: false,
        };
    },

    created() {
        this.$store.dispatch("ui/recaptcha/setReady", {recaptchaId: this.captchaId, value: false});
        this.$store.dispatch("ui/recaptcha/setResponse", {response: null, recaptchaId: this.captchaId});
        console.log(this.rqdata)
        if (this.rqdata) console.info("using rqdata")
        if (!this.rqdata) console.info("NOT using rqdata")
    },

    beforeDestroy() {
        this.$store.dispatch("ui/recaptcha/setReady", {recaptchaId: this.captchaId, value: false});
        this.$store.dispatch("ui/recaptcha/setResponse", {response: null, recaptchaId: this.captchaId});
    },

    methods: {
        onVerify: function (response) {
            console.log(`Verify hcaptcha (id: ${this.captchaId}, ts:${Date.now()}): ${response}`);
            this.validResponse = response;
            this.$store.dispatch("ui/recaptcha/setResponse", {response, recaptchaId: this.captchaId});
        },
        onExpired: function () {
            console.log(`Expired hcaptcha (id: ${this.captchaId}, ts:${Date.now()})`);
            this.validResponse = null;
            this.$store.dispatch("ui/recaptcha/setResponse", {response: null, recaptchaId: this.captchaId});
        },
        onRender: function () {
            // console.log('Rendered');
            this.isRendered = true;
            this.$store.dispatch("ui/recaptcha/setReady", {recaptchaId: this.captchaId});
        },
        reset: function () {
            this.$refs.hcaptcha.reset();
            this.onExpired();
        },
    },
    mounted: function() {
      this.$store.dispatch("ui/recaptcha/setCaptchaComponent", this);
    }
}
</script>
